import { stripHtmlTags } from '../utils';

const fallbackBlogPosts = [
    {
        id: 'fallback-1',
        title: 'Community Mental Health Outreach',
        description: 'We continue expanding access to compassionate mental health support through community outreach and awareness programs.',
        content: '<p>We continue expanding access to compassionate mental health support through community outreach and awareness programs.</p>',
        date: 'March 1, 2026',
        image: '/src/assets/images/blog_thumbnail_small_img_1.jpg',
        alt: 'Community outreach activity',
        author: 'DMA Foundation',
        category: 'Mental Health',
        slug: 'community-mental-health-outreach',
        index: 0,
    },
    {
        id: 'fallback-2',
        title: 'Rehabilitation Support Sessions',
        description: 'Our team delivered focused rehabilitation support sessions for people recovering from substance use and psychosocial distress.',
        content: '<p>Our team delivered focused rehabilitation support sessions for people recovering from substance use and psychosocial distress.</p>',
        date: 'February 21, 2026',
        image: '/src/assets/images/blog_thumbnail_small_img_2.jpg',
        alt: 'Rehabilitation support activity',
        author: 'DMA Foundation',
        category: 'Rehabilitation',
        slug: 'rehabilitation-support-sessions',
        index: 1,
    },
    {
        id: 'fallback-3',
        title: 'Volunteer Capacity Building',
        description: 'We organized volunteer capacity-building activities to strengthen frontline support for individuals and families in need.',
        content: '<p>We organized volunteer capacity-building activities to strengthen frontline support for individuals and families in need.</p>',
        date: 'February 10, 2026',
        image: '/src/assets/images/blog_thumbnail_small_img_3.jpg',
        alt: 'Volunteer training activity',
        author: 'DMA Foundation',
        category: 'Community',
        slug: 'volunteer-capacity-building',
        index: 2,
    },
];

const resolveCategory = (tag) => {
    if (typeof tag === 'string') {
        return tag;
    }

    if (tag && typeof tag === 'object') {
        return tag.name || tag.value || 'Mental Health';
    }

    return 'Mental Health';
};

const mapPost = (post, index) => {
    const title = post.title?.[0]?.value || 'Untitled';
    const body = post.body?.[0]?.value || '';
    const created = post.created?.[0]?.value || new Date().toISOString();
    const image = post.field_image?.[0]?.url || '/src/assets/images/blog_thumbnail_img_1.jpg';
    const alt = post.field_image?.[0]?.alt || title;
    const cleanBody = stripHtmlTags(body);
    const description = cleanBody.length > 200 ? `${cleanBody.substring(0, 200)}...` : cleanBody;

    return {
        id: post.nid?.[0]?.value || index + 1,
        title,
        description,
        content: body,
        date: new Date(created).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }),
        image,
        alt,
        author: 'DMA Foundation',
        category: resolveCategory(post.field_tags?.[0]),
        slug: title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''),
        index,
    };
};

// Function to fetch all blog posts from the API
export const fetchAllBlogPosts = async () => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 8000);

    try {
        const response = await fetch('https://api.dmaimpact.org/blog-view?_format=json', {
            signal: controller.signal,
        });

        if (!response.ok) {
            return fallbackBlogPosts;
        }

        const data = await response.json();

        if (!Array.isArray(data)) {
            return fallbackBlogPosts;
        }

        const mappedPosts = data.map(mapPost).filter(Boolean);
        return mappedPosts.length > 0 ? mappedPosts : fallbackBlogPosts;
    } catch (error) {
        return fallbackBlogPosts;
    } finally {
        clearTimeout(timeoutId);
    }
};

// For backward compatibility, export an empty array as default
const blogData = [];

export default blogData;
